<template>
  <p v-if="metadataStore.conferenceDate" class="font-medium text-brand-gray-900 text-sm-big-number md:text-big-number">{{ metadataStore.conferenceDate }}—PRAHA</p>
</template>

<script setup>
import { useMetadataStore} from "../stores/metadata";
const metadataStore = useMetadataStore();
</script>
